var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.hasChildEvents)?_c('ExpandableTimelineItem',{attrs:{"event":_vm.event,"hide-right-if-same":_vm.hideRightIfSame,"display-arrow":_vm.displayArrow,"hide-time-zone":_vm.hideTimeZone,"is-expand-content":_vm.isExpandContent,"expand-content-component":_vm.expandContentComponent,"expand-content-props":{
      hideTimeZone: true,
      hasMoreData: _vm.expandContentHasMoreData(_vm.event),
      isExpandContent: true,
      isLoading: _vm.isLoading,
    }}}):_c('TimelineItemContent',_vm._b({attrs:{"hide-right-if-same":_vm.hideRightIfSame,"display-arrow":_vm.displayArrow,"hide-time-zone":_vm.hideTimeZone}},'TimelineItemContent',_vm.event,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }